<section class="card takePhoto getSkinAnalysis pos-rel flex-col m16 bdr-rad-20 pB20 rebranded-diet-banner tw-overflow-hidden tw-rounded-tr-4 tw-rounded-tl-4" id="takePhoto" *ngIf="userStatus.PAID" (click)="handleClick()">
  <img class="w100 tw-mb-4" src=" https://cdn.cureskin.com/app/img/diet-banner.png" style="height: 180px; object-fit: cover" />
  <div class="nutritionist pos-abs pos-top-left mL15 mT15" i18n="@@nutritionist">
    Nutritionist
  </div>
  <div class="fw-700 font20 mL16" i18n="@@getDietPlan">Get a diet plan</div>
  <div class="tw-flex tw-items-end">
    <div class="tw-flex-1 tw-flex tw-flex-col tw-self-center">
      <div class="mL16" i18n="@@receiveDailyMealPlan">
        Receive daily meal plan for<span class="fw-600">
          healthy skin & hair</span>
      </div>
    </div>
    <div
      class="tw-bg-teal-600 tw-flex tw-items-center tw-justify-center tw-rounded-2 tw-h-8 tw-px-4 tw-mr-4"
      role="button"
    >
      <span class="tw-font-body tw-tracking-normal tw-capitalize tw-text-200 tw-font-semibold tw-text-white" i18n="@@clickHere">Click Here</span><cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'chevron_right'"></cs-icon>
    </div>
  </div>
</section>
